import MonsterButton from './MonsterButton';

import { AlignCenter, AlignLeft, AlignRight, Bold, Italic, List, ListOrdered } from 'lucide-react';

import type { Editor } from '@tiptap/react';

interface Props {
  editor: Editor | null;
}

export default function MonsterMenuBar({ editor }: Props) {
  if (!editor) return null;

  const options = [
    {
      icon: <Bold className='size-4' />,
      onClick: () => editor.chain().focus().toggleBold().run(),
      pressed: editor.isActive('bold')
    },
    {
      icon: <Italic className='size-4' />,
      onClick: () => editor.chain().focus().toggleItalic().run(),
      pressed: editor.isActive('italic')
    },

    {
      icon: <AlignLeft className='size-4' />,
      onClick: () => editor.chain().focus().setTextAlign('left').run(),
      pressed: editor.isActive('italic')
    },
    {
      icon: <AlignCenter className='size-4' />,
      onClick: () => editor.chain().focus().setTextAlign('center').run(),
      pressed: editor.isActive('center')
    },
    {
      icon: <AlignRight className='size-4' />,
      onClick: () => editor.chain().focus().setTextAlign('right').run(),
      pressed: editor.isActive('right')
    },
    {
      icon: <List className='size-4' />,
      onClick: () => editor.chain().focus().toggleBulletList().run(),
      pressed: editor.isActive('bulletList')
    },
    {
      icon: <ListOrdered className='size-4' />,
      onClick: () => editor.chain().focus().toggleOrderedList().run(),
      pressed: editor.isActive('orderedList')
    }
  ];

  return (
    <div className='bg-siteBackground border-monsterGreen flex flex-wrap gap-3 rounded-lg border-2 px-3 py-2'>
      {options.map((option, i) => (
        <MonsterButton fit type='button' colorSwap key={i} onClick={option.onClick}>
          {option.icon}
        </MonsterButton>
      ))}
    </div>
  );
}
